export default __webpack_public_path__ + "static/case-5-cc51425517bdd7311bbd99679117c6fa.webp";